/**
 * The brand, on the GLOBAL symbol registry rather than a module-local one: a
 * lazy route chunk and the kit can hold two copies of this module, and
 * `instanceof` across them answers false for a value that is exactly what it
 * claims to be.
 */
const CANCELLED = Symbol.for('dynamic-form.cancelled-submit');

/**
 * What a caller's `onSubmit` throws to say **the operator called it off** — a
 * declined `dangerous` confirmation, not a failure.
 *
 * A rejection is the only way to stop a submit from inside `onSubmit` (returning
 * normally means "saved"), and every other rejection is mapped onto the fields as
 * a server refusal. Without a sentinel the two are indistinguishable, so a
 * declined confirmation printed an error over a form the operator had simply
 * chosen not to save — which is what `SettingRow` did with `new Error('cancelled')`
 * until P10.3c.
 */
export class CancelledSubmit extends Error {
  readonly [CANCELLED] = true;

  constructor() {
    super('The submit was cancelled by the caller.');
    this.name = 'CancelledSubmit';
  }
}

export function isCancelledSubmit(value: unknown): boolean {
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as Record<symbol, unknown>)[CANCELLED] === true
  );
}
